var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisteredBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 27,
    viewBox: "0 0 43 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2517 12.5993C13.5074 12.5993 16.1987 10.031 16.1987 6.79964C16.1987 3.5683 13.5074 1 10.2517 1C6.99598 1 4.30469 3.5683 4.30469 6.79964C4.30469 10.031 6.99598 12.5993 10.2517 12.5993Z",
    stroke: "#39A2DB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.245 25.9972C12.6134 25.9972 14.8029 25.6264 16.4369 24.9922C17.2508 24.6764 17.9776 24.2757 18.5182 23.7797C19.0595 23.2831 19.4901 22.6144 19.4901 21.7974C19.4901 20.9804 19.0595 20.3118 18.5182 19.8151C17.9776 19.3191 17.2508 18.9184 16.4369 18.6026C14.8029 17.9684 12.6134 17.5977 10.245 17.5977C7.87668 17.5977 5.68718 17.9684 4.05312 18.6026C3.2393 18.9184 2.51242 19.3191 1.97186 19.8151C1.43056 20.3118 1 20.9804 1 21.7974C1 22.6144 1.43056 23.2831 1.97186 23.7797C2.51242 24.2757 3.2393 24.6764 4.05312 24.9922C5.68718 25.6264 7.87668 25.9972 10.245 25.9972Z",
    stroke: "#39A2DB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6426 6.27344L31.0441 16.9569L26.2266 12.1008",
    stroke: "#39A2DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredBlue);
export default __webpack_public_path__ + "static/media/Registered_Blue.01ee2b660e198cd5107bc7bb29b3954d.svg";
export { ForwardRef as ReactComponent };